import styled from 'styled-components';

const Container = styled.div`
  background-color: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  padding: 2rem;
  margin: 0 0.5rem;
  width: 27rem;
  height: 100%;
  display: inline-block;
  vertical-align: middle;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

const UserImage = styled.img`
  width: 5.6rem;
  height: 5.6rem;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 1.2rem;
  flex: none;
`;

const UserName = styled.p`
  color: var(--ink);
  font-size: 1.6rem;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: normal;
`;

const ProjectName = styled.p`
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 1.6rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const Review = styled.p`
  color: var(--ink-faint);
  margin-top: 1rem;
  white-space: normal;
`;

const RateContainer = styled.div`
  display: flex;
  margin-top: 0.5rem;

  svg:not(:first-child) {
    margin-left: 0.5rem;
  }
`;

export {
  Container,
  UserInfo,
  UserImage,
  UserName,
  ProjectName,
  Review,
  RateContainer,
};
